import { render, staticRenderFns } from "./Revisions.vue?vue&type=template&id=bd26d08a&scoped=true&lang=pug&"
import script from "./Revisions.vue?vue&type=script&lang=js&"
export * from "./Revisions.vue?vue&type=script&lang=js&"
import style0 from "./Revisions.vue?vue&type=style&index=0&id=bd26d08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd26d08a",
  null
  
)

export default component.exports